import React from "react";
import { Box, Chip, Tooltip } from "@mui/material";
import { getCatalogVisibilityBadges } from "./productCatalogStatus";

const SUPPORT_STATUS_TOOLTIP = "Per maggiori informazioni sullo stato dei prodotti contatta l'assistenza";

const chipSx = {
  fontFamily: "Rubik, sans-serif",
  fontWeight: 600,
  fontSize: 11,
  height: 22,
};

export default function ProductCatalogVisibilityBadges({ product, sx }) {
  const visibilityBadges = getCatalogVisibilityBadges(product);

  if (visibilityBadges.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.5,
        flexShrink: 0,
        minWidth: 88,
        ...sx,
      }}
    >
      {visibilityBadges.map((badge) => (
        <Tooltip key={badge.label} title={SUPPORT_STATUS_TOOLTIP} arrow>
          <Chip
            label={badge.label}
            size="small"
            sx={{
              ...chipSx,
              backgroundColor: `${badge.color}18`,
              color: badge.color,
              cursor: "help",
            }}
          />
        </Tooltip>
      ))}
    </Box>
  );
}
